document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(max-width: 749px)').matches) {
    document.querySelectorAll('.collection-filter__group').forEach(function (g) {
      g.classList.add('is-collapsed');
    });
  }
});document.addEventListener('click', function (e) {
  // Header alanına tıklanınca (title veya inner)
  var header =
    e.target.closest('.collection-filter__title') ||
    e.target.closest('.collection-filter__inner');

  if (!header) return;

  var group = header.closest('.collection-filter__group');
  if (!group) return;

  // Eğer tıklama içerik alanındaysa (checkboxlar vs), toggle yapma
  if (e.target.closest('.tag-list') || e.target.closest('.price-range')) return;

  // Sadece 1 tane açık kalsın
  document.querySelectorAll('.collection-filter__group').forEach(function (g) {
    if (g !== group) g.classList.add('is-collapsed');
  });

  group.classList.toggle('is-collapsed');
});document.addEventListener('DOMContentLoaded', function () {
  // Only on mobile
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var filtersRoot = document.querySelector('.collection-filters');
  var form = document.querySelector('.collection-filters .filter-form.collection-filter__scrollable');
  if (!filtersRoot || !form) return;

  // Create overlay
  var overlay = document.createElement('div');
  overlay.className = 'onesck-filters-overlay';
  document.body.appendChild(overlay);

  function openDrawer(){
    document.body.classList.add('onesck-filters-open');
  }
  function closeDrawer(){
    document.body.classList.remove('onesck-filters-open');
  }

  overlay.addEventListener('click', closeDrawer);

  // Create "Filter" button (above filters area)
  var btnWrap = document.createElement('div');
  btnWrap.className = 'onesck-filter-button-wrap';

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'onesck-filter-button';
  btn.textContent = 'Filter';

  btn.addEventListener('click', openDrawer);

  btnWrap.appendChild(btn);
  filtersRoot.insertBefore(btnWrap, filtersRoot.firstChild);

  // Add a topbar inside the drawer (once)
  if (!form.querySelector('.onesck-filters-topbar')) {
    var topbar = document.createElement('div');
    topbar.className = 'onesck-filters-topbar';

    var title = document.createElement('p');
    title.className = 'onesck-filters-topbar__title';
    title.textContent = 'Filters';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'onesck-filters-close';
    closeBtn.textContent = 'Close';
    closeBtn.addEventListener('click', closeDrawer);

    topbar.appendChild(title);
    topbar.appendChild(closeBtn);

    form.insertBefore(topbar, form.firstChild);
  }

  // Close drawer on ESC
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeDrawer();
  });
});// ===== ONESCK: Close mobile filter panel after selecting a value =====
document.addEventListener('change', function (e) {
  // only mobile
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  // if the change happened inside the filter form (checkbox / radio / select)
  var form = e.target.closest('.filter-form.collection-filter__scrollable');
  if (!form) return;

  // close the drawer/panel (same class we used before)
  document.body.classList.remove('onesck-filters-open');

  // scroll back to products (adjust selector if needed)
  var grid =
    document.querySelector('.collection-grid') ||
    document.querySelector('#Collection') ||
    document.querySelector('.collection') ||
    document.querySelector('.grid');
  if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
});